export default __webpack_public_path__ + "static/base-lite-5-ddf5e0f038a7e2b45f8d1ecc72ee62d5.jpg";